/**
 * Mutation hook for deleting a Pricing Rule (undo action).
 *
 * Used by the success toast's "Undo" button to immediately
 * delete the newly created Pricing Rule.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { frappeMethod } from "@/lib/erp/utils";

// ── Types ────────────────────────────────────────────────────

interface DeletePromotionResponse {
  status: string;
  name: string;
}

// ── Hook ─────────────────────────────────────────────────────

export function useDeletePromotion(itemCode: string) {
  const queryClient = useQueryClient();

  return useMutation<DeletePromotionResponse, Error, string>({
    mutationFn: (pricingRuleName: string) =>
      frappeMethod<DeletePromotionResponse>(
        "zaviago_backend.api.pricing_promotion_actions.delete_promotion",
        { pricing_rule_name: pricingRuleName }
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["pricing-summary", itemCode],
      });
    },
  });
}
